import React, { useState, useEffect, FC } from 'react'
import GeoLocationConnector, { ConnectorProps as GeoLocationProps } from 'connectors/GeoLocation'
import CarouselConnector, {
  ConnectorProps as CarouselProps,
} from '../../../connectors/CarouselABTest'
import { ALGOLIA, VISII } from '../../../helpers/constants'
import Carousel from './Carousel'
import { getRelatedArtworks, clickArtwork } from '../helpers'
import { Section } from './styles'
import classNames from 'classnames'
import { getAlgoliaQueryIDFromLocalStorage } from 'lib/algolia/v2/helpers'

const MIN_ARTWORKS = 5
const LIST = 'visually-similar'

type Props = CarouselProps &
  GeoLocationProps & {
    shouldLoadComponent: boolean
    setShouldLoadComponent: (...args: Array<any>) => any
  }

const RecommendedArtworksCarousel: FC<Props> = (props) => {
  const [artworks, handleArtworks] = useState([])
  const {
    artworkId,
    category,
    geoLocation,
    hasSession,
    isArtist,
    mediums,
    relatedSeeMore,
    sku,
    styles,
    subject,
    visiiMetadata,
    shouldLoadComponent,
    setShouldLoadComponent,
    algoliaSearchIndex,
    algoliaUserToken,
    userID,
  } = props
  const { destinationZone } = geoLocation
  const algoliaQueryIdFromLocalStorage = getAlgoliaQueryIDFromLocalStorage()
  useEffect(() => {
    if (hasSession && shouldLoadComponent) {
      getRelatedArtworks({
        abTest: true,
        artworkId,
        callBack: handleArtworks,
        category,
        destinationZone: destinationZone,
        isArtist,
        mediums,
        metadata: visiiMetadata,
        sku,
        styles,
        subject,
      })
    }
  }, [artworkId, hasSession, shouldLoadComponent, destinationZone])

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  const dataApi = artworks[0].api === VISII ? VISII : ALGOLIA
  return (
    <Section data-section={LIST} data-api={dataApi}>
      <h4
        className={classNames('defaultTypographyH4', 'defaultTextBold')}
        data-type='visii-carousel-title'
      >
        Visually Similar Artworks
      </h4>
      <Carousel
        artworks={artworks}
        clickArtwork={(ev) => {
          setShouldLoadComponent(false)
          clickArtwork(ev, algoliaSearchIndex, algoliaUserToken, userID)
        }}
        dataApi={dataApi}
        dataList={`${LIST}-pdp`}
        dataListId={`${LIST}-pdp`}
        dataListName='Visually Similar Artworks'
        seeMore={relatedSeeMore}
        parentDataSection={LIST}
        algoliaSearchIndex={algoliaSearchIndex}
        algoliaUserToken={algoliaUserToken}
        algoliaQueryID={algoliaQueryIdFromLocalStorage}
        userID={userID}
      />
    </Section>
  )
}

export default GeoLocationConnector(CarouselConnector(RecommendedArtworksCarousel))
